import "./environment-indicator.css";

import { environmentConfig } from "~/shared/utils/environment-config.ts";

export function EnvironmentIndicator() {
	const envName = environmentConfig.environmentName;

	// Only show for local, dev and stage environments
	if (envName !== "local" && envName !== "dev" && envName !== "stage") {
		return null;
	}

	const displayText = envName.toUpperCase();
	const cssClass = `environment-indicator environment-indicator-${envName}`;

	return (
		<div className={cssClass} data-testid={"environment-indicator"}>
			{displayText}
		</div>
	);
}
